export const CHAT_DATA_REQUEST = "CHAT_DATA_REQUEST"
export const CHAT_DATA_SUCCESS = "CHAT_DATA_SUCCESS"
export const CHAT_DATA_FAILED = "CHAT_DATA_FAILED"
